// 提醒音频文件 - 这是一个简单的音频提醒功能
// 在实际项目中，您需要准备一个音频文件
// 这里我们使用Web Audio API创建一个简单的提醒音

class ReminderService {
  constructor() {
    this.audioContext = null;
    this.isSupported = 'AudioContext' in window || 'webkitAudioContext' in window;
  }

  // 创建简单的提醒音
  createNotificationSound() {
    if (!this.isSupported) {
      console.warn('Web Audio API not supported');
      return;
    }

    try {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // 创建振荡器
      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();
      
      // 设置音频参数
      oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
      oscillator.frequency.setValueAtTime(600, this.audioContext.currentTime + 0.1);
      oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime + 0.2);
      
      gainNode.gain.setValueAtTime(0.3, this.audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.3);
      
      // 连接节点
      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);
      
      // 播放音频
      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + 0.3);
      
    } catch (error) {
      console.error('Error creating notification sound:', error);
    }
  }

  // 检查并播放提醒
  checkAndPlayReminder(events) {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();
    const currentDate = now.toISOString().split('T')[0];
    
    events.forEach(event => {
      if (event.reminder_enabled && event.event_date === currentDate && !event.is_completed) {
        if (event.start_time) {
          const [hours, minutes] = event.start_time.split(':').map(Number);
          const eventTime = hours * 60 + minutes;
          
          // 如果事件时间接近当前时间（前后5分钟内），播放提醒
          if (Math.abs(eventTime - currentTime) <= 5) {
            this.createNotificationSound();
            console.log(`提醒: ${event.title}`);
          }
        }
      }
    });
  }

  // 启动提醒服务
  startReminderService(events) {
    // 每分钟检查一次
    setInterval(() => {
      this.checkAndPlayReminder(events);
    }, 60000); // 60秒
    
    // 立即检查一次
    this.checkAndPlayReminder(events);
  }
}

export default ReminderService;
